// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bcs_a bhl_ea bhl_ke bhl_ju bhl_sn bhl_wl"};